import { __assign, __extends, __rest } from "tslib";
import * as React from "react";
import { Animated, View, StyleSheet } from "react-native";
import color from "color";
import { RadioButtonContext } from "../RadioButtonGroup";
import { handlePress, isChecked } from "../utils";
import TouchableRipple from "../../TouchableRipple";
import defaultTheme from "../../styles/defaultTheme";
var BORDER_WIDTH = 2;
var RadioButton = /** @class */function (_super) {
  __extends(RadioButton, _super);
  function RadioButton() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      borderAnim: new Animated.Value(BORDER_WIDTH),
      radioAnim: new Animated.Value(1)
    };
    return _this;
  }
  RadioButton.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.status === this.props.status) {
      return;
    }
    if (this.props.status === "checked") {
      this.state.radioAnim.setValue(1.2);
      Animated.timing(this.state.radioAnim, {
        toValue: 1,
        duration: 150 * 1.0
      }).start();
    } else {
      this.state.borderAnim.setValue(10);
      Animated.timing(this.state.borderAnim, {
        toValue: BORDER_WIDTH,
        duration: 150 * 1.0
      }).start();
    }
  };
  RadioButton.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      disabled = _a.disabled,
      onPress = _a.onPress,
      theme = _a.theme,
      value = _a.value,
      status = _a.status,
      rest = __rest(_a, ["disabled", "onPress", "theme", "value", "status"]);
    var checkedColor = this.props.color || "#1d60f6";
    var uncheckedColor = this.props.uncheckedColor || color("#1d60f6").alpha(0.54).rgb().string();
    var rippleColor, radioColor;
    return /*#__PURE__*/React.createElement(RadioButtonContext.Consumer, null, function (context) {
      var checked = isChecked({
        contextValue: context === null || context === void 0 ? void 0 : context.value,
        status: status,
        value: value
      }) === "checked";
      if (disabled) {
        rippleColor = color("#1d60f6").alpha(0.16).rgb().string();
        radioColor = color('#bdbdbd').alpha(0.26).rgb().string();
      } else {
        rippleColor = color(checkedColor).fade(0.32).rgb().string();
        radioColor = checked ? checkedColor : uncheckedColor;
      }
      return /*#__PURE__*/React.createElement(TouchableRipple, __assign({}, rest, {
        borderless: true,
        rippleColor: rippleColor,
        onPress: disabled ? undefined : function () {
          handlePress({
            onPress: onPress,
            onValueChange: context === null || context === void 0 ? void 0 : context.onValueChange,
            value: value
          });
        },
        style: styles.container,
        nativeID: rest.idTag1
      }), /*#__PURE__*/React.createElement(Animated.View, {
        style: [styles.radio, {
          borderColor: radioColor,
          borderWidth: _this.state.borderAnim
        }],
        nativeID: rest.idTag2
      }, checked ? (/*#__PURE__*/React.createElement(View, {
        style: [StyleSheet.absoluteFill, styles.radioContainer],
        nativeID: rest.idTag3,
        accessibilityTraits: disabled ? ["button", "disabled"] : "button",
        accessibilityComponentType: checked ? "radiobutton_checked" : "radiobutton_unchecked",
        accessibilityRole: "radio",
        accessibilityLabel: "radio button",
        accessibilityStates: disabled ? ["disabled"] : [],
        accessibilityLiveRegion: "polite",
        "aria-checked": "true",
        title: "radio button"
      }, /*#__PURE__*/React.createElement(Animated.View, {
        style: [styles.dot, {
          backgroundColor: radioColor,
          transform: [{
            scale: _this.state.radioAnim
          }]
        }],
        nativeID: rest.idTag4
      }))) : null));
    });
  };
  RadioButton.displayName = "RadioButton.Android";
  return RadioButton;
}(React.Component);
var styles = StyleSheet.create({
  container: {
    borderRadius: 18
  },
  radioContainer: {
    alignItems: "center",
    justifyContent: "center"
  },
  radio: {
    height: 20,
    width: 20,
    borderRadius: 10,
    marginTop: 4,
    marginLeft: 8,
    marginRight: 8,
    marginBottom: 8
  },
  dot: {
    height: 10,
    width: 10,
    borderRadius: 5
  }
});
export default defaultTheme(RadioButton);